module.exports = "/templates/oauthlogin.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/oauthlogin.html
// module id = 455
// module chunks = 0